import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  MDBContainer, MDBCard, MDBCardBody, MDBBtn, MDBIcon,
  MDBRow, MDBCol, MDBTable, MDBTableBody, MDBTableHead
} from "mdbreact";
import API_URL from '../config';
import axios from 'axios';

class AdminGestionComprobantes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      busqueda: '',
      tipoBusqueda: 'serie',
      comprobantes: [],
      cargando: false,
      volverDashboard: false,
      // Edición
      editando: null,
      editSerie: '',
      editMonto: '',
      editExtras: '',
      modalExito: '',
      modalError: '',
      // Confirmación anulación
      modalConfirmarAnular: false,
      idAnular: null
    };
  }

  getToken = function() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  }

  buscar = function() {
    if (!this.state.busqueda.trim()) return;
    var token = this.getToken();
    this.setState({ cargando: true, comprobantes: [], editando: null });

    axios.post(API_URL + '/admin/buscarcomprobantes/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ busqueda: this.state.busqueda.trim(), tipo: this.state.tipoBusqueda, autorizacion: token })
    })
    .then(function(response) {
      this.setState({ comprobantes: response.data || [], cargando: false });
    }.bind(this))
    .catch(function(err) {
      console.error(err);
      this.setState({ cargando: false });
    }.bind(this));
  }

  iniciarEdicion = function(comp) {
    this.setState({
      editando: comp.IdComprobante,
      editSerie: comp.SerieNumero,
      editMonto: comp.MontoPagado,
      editExtras: ''
    });
  }

  guardarEdicion = function() {
    var token = this.getToken();
    this.setState({ modalError: '', modalExito: '' });

    axios.post(API_URL + '/admin/editarcomprobante/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({
        id_comprobante: this.state.editando,
        serie_numero: this.state.editSerie,
        monto_pagado: parseFloat(this.state.editMonto),
        descargas_extras_nuevos: this.state.editExtras ? parseInt(this.state.editExtras) : 0,
        autorizacion: token
      })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0 && response.data[0].Resultado === 'OK') {
        this.setState({ modalExito: 'Comprobante actualizado correctamente', editando: null });
        this.buscar();
      } else {
        var msg = response.data && response.data[0] ? response.data[0].Mensaje : 'Error al actualizar';
        this.setState({ modalError: msg });
      }
    }.bind(this))
    .catch(function(err) {
      console.error(err);
      this.setState({ modalError: 'Error de conexión' });
    }.bind(this));
  }

  confirmarAnular = function(id) {
    this.setState({ modalConfirmarAnular: true, idAnular: id });
  }

  anularComprobante = function() {
    var id = this.state.idAnular;
    var token = this.getToken();
    this.setState({ modalConfirmarAnular: false, idAnular: null });
    axios.post(API_URL + '/admin/anularcomprobante/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ id_comprobante: id, autorizacion: token })
    })
    .then(function(response) {
      this.setState({ modalExito: 'Comprobante anulado correctamente' });
      this.buscar();
    }.bind(this))
    .catch(function(err) { console.error(err); }.bind(this));
  }

  render() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    if (!datos || !datos[0]) return <Redirect to="/" />;
    if (this.state.volverDashboard) return <Redirect push={false} to={{ pathname: "/admin-dashboard", state: { datos: datos } }} />;

    return (
      <div style={{ minHeight: "calc(100vh - 4rem)", background: "#f0f2f5" }}>
        <MDBContainer className="pt-4 pb-3">
          <MDBBtn onClick={function() { this.setState({ volverDashboard: true }); }.bind(this)}
            style={{ borderRadius: '8px', margin: '0 0 16px 0', fontWeight: '500', fontSize: '0.85rem', padding: '8px 20px', background: '#7A1622', border: 'none', color: '#fff' }}>
            <MDBIcon icon="arrow-left" className="mr-2" />Volver al Panel
          </MDBBtn>

          {/* Búsqueda */}
          <MDBCard style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 12px rgba(245,124,0,0.12)', overflow: 'hidden' }}>
            <div style={{ background: 'linear-gradient(135deg, #F57C00, #FB8C00)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MDBIcon icon="tools" style={{ color: '#fff', fontSize: '1.1rem' }} />
              <span style={{ color: '#fff', fontWeight: '600', fontSize: '0.95rem' }}>Gestión de Comprobantes</span>
            </div>
            <MDBCardBody style={{ padding: '20px 24px' }}>
              <MDBRow className="align-items-end">
                <MDBCol md="2" className="mb-2">
                  <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Buscar por</label>
                  <select className="browser-default custom-select" value={this.state.tipoBusqueda}
                    onChange={function(e) { this.setState({ tipoBusqueda: e.target.value }); }.bind(this)}>
                    <option value="serie">Serie-Número</option>
                    <option value="dni">DNI Trabajador</option>
                    <option value="operador">Operador</option>
                  </select>
                </MDBCol>
                <MDBCol md="4" className="mb-2">
                  <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Valor</label>
                  <input type="text" className="form-control" placeholder="Ingrese valor de búsqueda..."
                    value={this.state.busqueda} onChange={function(e) { this.setState({ busqueda: e.target.value }); }.bind(this)}
                    onKeyPress={function(e) { if (e.key === 'Enter') this.buscar(); }.bind(this)} />
                </MDBCol>
                <MDBCol md="2" className="mb-2">
                  <MDBBtn onClick={this.buscar.bind(this)} style={{ borderRadius: '8px', margin: 0, fontWeight: '600', fontSize: '0.85rem', padding: '10px 24px', background: '#F57C00', border: 'none', color: '#fff', width: '100%' }}>
                    <MDBIcon icon="search" className="mr-2" />Buscar
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>

          {/* Resultados */}
          <MDBCard className="mt-3" style={{ borderRadius: '10px' }}>
            <MDBCardBody>
              <h6 style={{ color: '#F57C00', fontWeight: '600', marginBottom: '12px' }}>
                <MDBIcon icon="list" className="mr-2" />Comprobantes Encontrados
              </h6>
              {this.state.cargando ? (
                <div className="text-center py-4"><MDBIcon icon="spinner" spin size="2x" style={{ color: '#F57C00' }} /></div>
              ) : this.state.comprobantes.length > 0 ? (
                <MDBTable striped small responsive style={{ fontSize: '0.82rem' }}>
                  <MDBTableHead>
                    <tr>
                      <th>ID</th>
                      <th>Tipo</th>
                      <th>Serie-Número</th>
                      <th>DNI</th>
                      <th>Monto</th>
                      <th>Boletas</th>
                      <th>Extras</th>
                      <th>Descargas</th>
                      <th>Restantes</th>
                      <th>Operador</th>
                      <th>Fecha</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {this.state.comprobantes.map(function(c) {
                      // 11/08/2026 - un expediente no lleva monto ni tope. Sin
                      // distinguirlo, se veria como un comprobante averiado:
                      // S/ 0, 0 boletas y restantes en rojo.
                      var esExpediente = c.TipoDocumento === 'EXPEDIENTE';
                      var restantes = c.CantidadBoletas - c.DescargasRealizadas;
                      var esEditando = this.state.editando === c.IdComprobante;

                      return (
                        <React.Fragment key={c.IdComprobante}>
                        <tr style={{ background: esEditando ? '#fff8e1' : 'transparent' }}>
                          <td>{c.IdComprobante}</td>
                          <td>
                            <span style={{
                              padding: '2px 8px', borderRadius: '10px', fontSize: '0.72rem', fontWeight: '600',
                              whiteSpace: 'nowrap',
                              background: esExpediente ? '#e0f7fa' : '#fff3e0',
                              color: esExpediente ? '#00838F' : '#E65100'
                            }}>
                              {esExpediente ? 'Expediente' : 'Comprobante'}
                            </span>
                          </td>
                          <td>{c.SerieNumero}</td>
                          <td>{c.DniTrabajador}</td>
                          <td>{esExpediente ? '—' : (c.MontoPagado ? 'S/ ' + c.MontoPagado : '')}</td>
                          <td>{esExpediente ? 'Sin tope' : c.CantidadBoletas}</td>
                          <td style={{ color: c.DescargasExtras > 0 ? '#2E7D32' : '#999', fontWeight: c.DescargasExtras > 0 ? '700' : '400' }}>
                            {esExpediente ? '—' : (c.DescargasExtras > 0 ? '+' + c.DescargasExtras : '0')}
                          </td>
                          <td>{c.DescargasRealizadas}</td>
                          <td style={{ color: esExpediente ? '#00838F' : (restantes > 0 ? '#2E7D32' : '#C62828'), fontWeight: '700' }}>
                            {esExpediente ? '—' : restantes}
                          </td>
                          <td>{c.UsuarioRegistro}</td>
                          <td style={{ fontSize: '0.78rem' }}>{c.FechaRegistro}</td>
                          <td>
                            <span style={{
                              padding: '2px 8px', borderRadius: '10px', fontSize: '0.75rem', fontWeight: '600',
                              background: c.Estado ? '#e8f5e9' : '#fdecea', color: c.Estado ? '#2E7D32' : '#C62828'
                            }}>
                              {c.Estado ? 'Activo' : 'Anulado'}
                            </span>
                          </td>
                          <td>
                            {!esEditando && c.Estado ? (
                              <div style={{ display: 'flex', gap: '4px' }}>
                                <button type="button" onClick={function() { this.iniciarEdicion(c); }.bind(this)}
                                  style={{ borderRadius: '6px', margin: 0, padding: '5px 12px', backgroundColor: '#1565C0', border: 'none', color: '#fff', fontSize: '0.75rem', cursor: 'pointer', fontWeight: '600' }}>
                                  <MDBIcon icon="edit" className="mr-1" />Editar
                                </button>
                                <button type="button" onClick={function() { this.confirmarAnular(c.IdComprobante); }.bind(this)}
                                  style={{ borderRadius: '6px', margin: 0, padding: '5px 12px', backgroundColor: '#ef5350', border: 'none', color: '#fff', fontSize: '0.75rem', cursor: 'pointer', fontWeight: '600' }}>
                                  <MDBIcon icon="ban" className="mr-1" />Anular
                                </button>
                              </div>
                            ) : !c.Estado ? (
                              <span style={{ color: '#999', fontSize: '0.78rem' }}>-</span>
                            ) : (
                              <span style={{ color: '#1565C0', fontWeight: '600', fontSize: '0.75rem' }}><MDBIcon icon="pen" className="mr-1" />Editando...</span>
                            )}
                          </td>
                        </tr>
                        {esEditando && (
                          <tr>
                            <td colSpan="13" style={{ padding: 0 }}>
                              <div style={{ background: '#fff8e1', padding: '16px 24px', borderLeft: '4px solid #F57C00' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                  <MDBIcon icon="edit" style={{ color: '#F57C00' }} />
                                  <span style={{ fontWeight: '700', color: '#E65100', fontSize: '0.9rem' }}>
                                    Editando {esExpediente ? 'expediente' : 'comprobante'} #{c.IdComprobante}
                                  </span>
                                </div>
                                {/* En un expediente solo se puede corregir el numero:
                                    no lleva monto ni tope, asi que las descargas
                                    extras tampoco tienen sentido. */}
                                <MDBRow className="align-items-end">
                                  <MDBCol md={esExpediente ? "6" : "3"} className="mb-2">
                                    <label style={{ fontWeight: '600', fontSize: '0.8rem', color: '#555' }}>
                                      {esExpediente ? 'N° de expediente' : 'Serie-Número'}
                                    </label>
                                    <input type="text" className="form-control" value={this.state.editSerie}
                                      onChange={function(e) { this.setState({ editSerie: e.target.value }); }.bind(this)} />
                                  </MDBCol>
                                  <MDBCol md="2" className="mb-2" style={{ display: esExpediente ? 'none' : 'block' }}>
                                    <label style={{ fontWeight: '600', fontSize: '0.8rem', color: '#555' }}>Monto (S/)</label>
                                    <input type="number" step="0.01" className="form-control" value={this.state.editMonto}
                                      onChange={function(e) { this.setState({ editMonto: e.target.value }); }.bind(this)} />
                                  </MDBCol>
                                  <MDBCol md="2" className="mb-2" style={{ display: esExpediente ? 'none' : 'block' }}>
                                    <label style={{ fontWeight: '600', fontSize: '0.8rem', color: '#555' }}>
                                      <MDBIcon icon="plus-circle" style={{ color: '#2E7D32' }} className="mr-1" />Agregar Extras
                                    </label>
                                    <input type="number" className="form-control" placeholder="0" value={this.state.editExtras}
                                      onChange={function(e) { this.setState({ editExtras: e.target.value }); }.bind(this)}
                                      style={{ borderColor: '#2E7D32' }} />
                                  </MDBCol>
                                  <MDBCol md="2" className="mb-2">
                                    {!esExpediente && this.state.editMonto && parseFloat(this.state.editMonto) >= 3 && (
                                      <div style={{ background: '#e3f2fd', borderRadius: '6px', padding: '8px 10px', textAlign: 'center' }}>
                                        <small style={{ color: '#888', fontSize: '0.7rem' }}>Total boletas</small>
                                        <div style={{ fontWeight: '800', fontSize: '1.2rem', color: '#1565C0' }}>
                                          {Math.floor(parseFloat(this.state.editMonto) / 3) + (c.DescargasExtras || 0) + (this.state.editExtras ? parseInt(this.state.editExtras) : 0)}
                                        </div>
                                      </div>
                                    )}
                                  </MDBCol>
                                  <MDBCol md="3" className="mb-2 d-flex align-items-end">
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                      <button type="button" onClick={this.guardarEdicion.bind(this)}
                                        style={{ borderRadius: '6px', margin: 0, padding: '7px 16px', backgroundColor: '#2E7D32', border: 'none', color: '#fff', fontWeight: '600', fontSize: '0.8rem', cursor: 'pointer' }}>
                                        <MDBIcon icon="save" className="mr-1" />Guardar
                                      </button>
                                      <button type="button" onClick={function() { this.setState({ editando: null }); }.bind(this)}
                                        style={{ borderRadius: '6px', margin: 0, padding: '7px 16px', backgroundColor: '#ef5350', border: 'none', color: '#fff', fontWeight: '600', fontSize: '0.8rem', cursor: 'pointer' }}>
                                        Cancelar
                                      </button>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                      );
                    }.bind(this))}
                  </MDBTableBody>
                </MDBTable>
              ) : (
                <div className="text-center py-4">
                  <MDBIcon icon="search" size="2x" style={{ color: '#ccc' }} />
                  <p style={{ color: '#999', marginTop: '8px' }}>Busque comprobantes por serie-número, DNI u operador</p>
                </div>
              )}
            </MDBCardBody>
          </MDBCard>
        </MDBContainer>

        {/* Modal Confirmación Anulación */}
        {this.state.modalConfirmarAnular && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '32px 36px', maxWidth: '460px', width: '92%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#fdecea', margin: '0 auto 18px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="ban" style={{ color: '#C62828', fontSize: '2rem' }} />
              </div>
              <p style={{ fontSize: '1.15rem', fontWeight: '700', color: '#C62828', marginBottom: '10px' }}>¿Anular comprobante?</p>
              <p style={{ fontSize: '0.92rem', color: '#555', marginBottom: '24px' }}>
                Esta acción marcará el comprobante <strong>#{this.state.idAnular}</strong> como anulado.<br />
                El operador no podrá realizar más descargas con este comprobante.
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <button type="button" onClick={this.anularComprobante.bind(this)}
                  style={{ borderRadius: '8px', padding: '10px 32px', backgroundColor: '#C62828', border: 'none', color: '#fff', fontWeight: '700', fontSize: '0.92rem', cursor: 'pointer' }}>
                  <MDBIcon icon="ban" className="mr-2" />Sí, anular
                </button>
                <button type="button" onClick={function() { this.setState({ modalConfirmarAnular: false, idAnular: null }); }.bind(this)}
                  style={{ borderRadius: '8px', padding: '10px 32px', backgroundColor: '#666', border: 'none', color: '#fff', fontWeight: '700', fontSize: '0.92rem', cursor: 'pointer' }}>
                  <MDBIcon icon="times" className="mr-2" />Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Éxito */}
        {this.state.modalExito && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '450px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#e8f5e9', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="check-circle" style={{ color: '#2E7D32', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.1rem', fontWeight: '700', color: '#2E7D32', marginBottom: '20px' }}>{this.state.modalExito}</p>
              <MDBBtn onClick={function() { this.setState({ modalExito: '' }); }.bind(this)}
                style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 40px', background: '#2E7D32', border: 'none', color: '#fff' }}>
                <MDBIcon icon="check" className="mr-2" />Aceptar
              </MDBBtn>
            </div>
          </div>
        )}

        {/* Modal Error */}
        {this.state.modalError && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '450px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fdecea', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="exclamation-triangle" style={{ color: '#c62828', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.1rem', fontWeight: '700', color: '#c62828', marginBottom: '20px' }}>{this.state.modalError}</p>
              <MDBBtn onClick={function() { this.setState({ modalError: '' }); }.bind(this)}
                style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 40px', background: '#7A1622', border: 'none', color: '#fff' }}>
                <MDBIcon icon="times" className="mr-2" />Cerrar
              </MDBBtn>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AdminGestionComprobantes;
